import React, { useState, useEffect, useContext } from 'react';
import { Box, Button, Card, CardContent, Grid, Modal, Switch, TextField, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { addField, fetchFields, updateField } from '../../redux/field/field.actions';
import FieldsManager from '../FieldsManager';
import FieldTypeSelector from '../FieldTypeSelector';
import { ThemeContext } from '../ThemeContext/ThemeContext';

const FieldConfigurator = (props) => {
    const { theme } = useContext(ThemeContext);
    const { fetchFields, fields, updateField, addField } = props;
    const [newField, setNewField] = useState({
        name: 'Teste',
        type: 'text',
        required: false,
        options: [],
        visible: false,
    });
    const [selectedFieldId, setSelectedFieldId] = useState(false);
    const [openFieldManager, setOpenFieldManager] = useState(false);
    const fieldTypeTranslations = {
        text: 'Texto',
        number: 'Número',
        date: 'Data',
        select: 'Seleção',
    };

    const handleButtonClick = (fieldId) => {
        setSelectedFieldId(fieldId);
        setOpenFieldManager(true);
    };

    // Carregar os campos existentes ao montar o componente
    useEffect(() => {
        fetchFields();
    }, [fetchFields]);

    // Handler para adicionar ou atualizar campos
    const handleSaveField = async () => {
        addField(newField);
        setNewField({})
    };

    const handleFieldUpdate = (updatedField) => {
        setNewField(updatedField);
    };

    return (
        <Card 
            elevation={0}
            sx={{
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 2,
                overflow: 'hidden',
            }}
        >
            <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: theme.palette.text.primary }}>
                    Configurar Campos de Ticket
                </Typography>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
                    Configure os campos personalizados que serão exibidos nos tickets.
                </Typography>

                <Grid container direction={'column'} spacing={2} sx={{ mb: 3 }}>
                    <Grid item>
                        <TextField
                            label="Label do Campo"
                            value={newField.name}
                            onChange={(e) => setNewField({ ...newField, name: e.target.value })}
                            fullWidth
                        />
                    </Grid>
                    <Grid item>
                        <FieldTypeSelector
                            value={newField.type}
                            field={newField}
                            setNewField={handleFieldUpdate}
                        />
                    </Grid>
                    <Grid item container alignItems={'center'}>
                        <Typography sx={{ color: theme.palette.text.primary }}>Campo é visível </Typography>
                        <Switch
                            checked={newField.visible}
                            onChange={(e) => setNewField({ ...newField, visible: e.target.checked })}
                        />
                    </Grid>
                </Grid>
                <Button 
                    onClick={handleSaveField} 
                    color="primary" 
                    variant="contained"
                    sx={{ 
                        textTransform: 'none',
                        px: 3,
                        py: 1,
                        fontWeight: 600,
                        mb: 3
                    }}
                >
                    Salvar Campo
                </Button>

                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: theme.palette.text.primary }}>
                    Campos existentes
                </Typography>
                {fields.map(field => {
                    return (
                        <Grid key={field.id} sx={{ mb: 1 }}>
                            <Grid container alignItems={'center'} justifyContent={'space-between'}
                                onClick={() => handleButtonClick(field.id)}
                                sx={{
                                    border: `1px solid ${theme.palette.divider}`,
                                    borderRadius: 2,
                                    padding: '0.75rem',
                                    margin: '0.5rem 0',
                                    cursor: 'pointer',
                                    backgroundColor: theme.palette.background.default,
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: theme.palette.mode === 'dark' 
                                            ? 'rgba(255, 255, 255, 0.05)' 
                                            : 'rgba(0, 0, 0, 0.02)',
                                    }
                                }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}>
                                    <Typography fontWeight={600} sx={{ color: theme.palette.text.primary }}>Nome</Typography>
                                    <Typography variant='body2' sx={{ color: theme.palette.text.secondary }}>{field.name}</Typography>
                                </Box>
                                <Box sx={{
                                    margin: '0 0.5rem', display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}>
                                    <Typography fontWeight={600} sx={{ color: theme.palette.text.primary }}>Tipo</Typography>
                                    <Typography variant='body2' sx={{ color: theme.palette.text.secondary }}>{fieldTypeTranslations[field.type]}</Typography>
                                </Box>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}>
                                    <Typography fontWeight={600} sx={{ color: theme.palette.text.primary }}>Habilitado</Typography>
                                    <Typography variant='body2' sx={{ color: theme.palette.text.secondary }}>{field.visible ? 'Sim' : 'Não'}</Typography>
                                </Box>
                            </Grid>
                            {selectedFieldId === field.id &&
                                <Modal
                                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'transparent' }}
                                    open={openFieldManager}
                                    onClose={() => setOpenFieldManager(false)}
                                >
                                    <FieldsManager field={field} updateField={updateField} setOpenFieldManager={setOpenFieldManager} />
                                </Modal>
                            }
                        </Grid>
                    )
                })}
            </CardContent>
        </Card>
    );
};

const mapStateToProps = state => {
    const { field } = state;
    const { fields } = field;
    return { field, fields };
};

const mapDispatchToProps = dispatch => ({
    fetchFields: () => dispatch(fetchFields()),
    updateField: (field) => dispatch(updateField(field)),
    addField: (field) => dispatch(addField(field)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FieldConfigurator);
